<template>
  <div>
    <form>
      <div class="row">
        <b-card
          style="
            border: solid 1px #f5a623;
            padding: 0px;
            width: 100%;
            margin-left: 1rem !important;
            margin-right: 1rem !important;
            background-color: #ebedef !important;
          "
        >
          <CCol sm="12">
            <div class="form-group">
              <label>Date</label>

              <VueDatePicker class="form-control" v-model="date" />
            </div>
          </CCol>
          <CCol sm="12">
            <div class="form-group">
              <label>Kilométrage</label>

              <input class="form-control" v-model="nb_klm" />
            </div>
          </CCol>

          <div
            class="row"
            v-for="(programme, index) in programmes"
            :key="index"
          >
            <img
              v-if="programmes.length > 1"
              v-on:click="removeProgramme(index)"
              src="https://img.icons8.com/fluency/48/000000/filled-trash.png"
              style="margin-top: 31px; height: 30px"
            />
            <!--   <b-button
                      v-if="programmes.length > 1"
                      v-on:click="removeProgramme(index)"
                      class="md-just-icon md-simple md-danger"
                    >
                      
                      Delete
                    </b-button> -->
            <div class="col">
              <div class="form-group">
                <label>QTS</label>
                <input
                  class="form-control personalise"
                  :name="`programmes[${index}][qts]`"
                  v-model="programme.qts"
                  type="number"
                />
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label>Prix</label>
                <input
                  class="form-control personalise"
                  :name="`programmes[${index}][prix]`"
                  v-model="programme.prix"
                  type="number"
                />
              </div>
            </div>
            <CCol sm="12">
              <div class="form-group">
                <!--   <label  style="color:black;">Ajouter votre description ici:</label>   -->
                <textarea
                  aria-label="description"
                  v-model="programme.designation"
                  placeholder="Ajouter votre designation ici ..."
                  addon-left-icon="ni ni-circle-08"
                  :name="`programmes[${index}][designation]`"
                  class="form-control"
                  id="description"
                  rows="4"
                  required
                ></textarea>
                <!--    <span class="text-red"  v-if="errors.description">{{errors.description[0]}}</span> -->
              </div>
              <hr
                style="padding: 5px; border-top: 3px solid #a12828 !important"
              />
            </CCol>
          </div>

          <img
            v-on:click="addNewProgramme"
            src="https://img.icons8.com/color/48/000000/add-property.png"
          />

          <CButton
            v-if="Number(somme) > 0"
            @click.prevent="create_mise_jour"
            type="submit"
            size="sm"
            color="warning"
            style="border-radius: 24px; margin-left: 22px"
            ><CIcon name="cil-check-circle" /> Ajouter service</CButton
          >
        </b-card>
      </div>
    </form>
  </div>
</template>


<style lang="scss" scoped>
.md-card {
  width: 98%;
  margin: 4px;
  margin-left: 11px;
  display: inline-block;
  vertical-align: top;
}
</style>

<script>
import Vue from "vue";
import { VueDatePicker } from "@mathieustan/vue-datepicker";
import "@mathieustan/vue-datepicker/dist/vue-datepicker.min.css";

import { apiDomain } from "../../config";
import axios from "axios";
export default {
  components: { VueDatePicker },
  name: "register",
  data() {
    return {
      numF:'',
      last_num_fac:{},
      get_societe_id_mise: {},
      //  selectedDate: new Date().toISOString().split("T")[0],
      selectedDate: "",
      // date: "2022-01-01",
      selectedEmployee: null,
      selectedCountry: null,
      /*  options: [
        { value: "1", text: "aa" },
        { value: "2", text: "ab" },
      ], */
      item: {
        id: "",
        matricule: "",
      },
      selected_societe: "",
      all_societe: [],
      options: [],
      //somme: "100",
      initial_qts: "",
      nom_chouffeur: "",
      matr: "",
      nb_klm: "",
      numero_sach: "",

      date: new Date().toISOString().split("T")[0],
      ajouter_par: "azouz",

      /*  {
          titre: "",
        
          description: ""
        } */
      programmes: [{ qts: "", designation: "", prix: "" ,prix_ca: ""}],
      details: [],
      sCats33: [],
      qts: [
        /*  {
          qts: "1",
        }, */
      ],
      detail_services: {},

      show: false,
      showdetailleModale: false,
      detaille: {
        titre: "",

        description: "",
      },
      errors: [],
      index: -1,

      /* -------------------- */

      showdetailleModaleDetails: false,

      detailleDetails: {
        detail_services_id: "",
      },
      /* ----------------------- */
      showdetailleModaleQts: false,

      detailleQts: {
        qts: "",
      },
      /*  */

      Cats: [],
      sCats: [],
      sCats3: [],

      categorie_id: null,
      text_null: "null",
    };
  },
  created() {
    this.get_societe_services();
    this.fetch_get_societe_id(this.$route.params.id);
    this.getCategories();
    this.fetch_get_last_num_fac();
  },
  mounted() {},
  computed: {
    getPrix(){
      const res = [];
      var prix = this.programmes;
      for (var i = 0; i < prix.length; i++) {
        var pr = prix[i].prix+',000';
        res.push(pr);
      } 
     return  res;

    },
    DD(){
      return this.date.substring(8,10);
    },
    MM(){
      return this.date.substring(5,7);
    },
    YYYY(){
      return this.date.substring(0,4);
    },
    date_S(){
return this.DD+"/"+this.MM+"/"+this.YYYY;
    },
    get_matr() {
      const mat = this.options;
      const res = [];

      for (var i = 0; i < mat.length; i++) {
        var sum = mat[i].matricule;
        res.push(sum);
      }

      return res;
    },

    somme: function () {
      var sum = 0;
      for (var i = 0; i < this.all_service.length; i++) {
        sum += this.all_service[i].prix * this.all_service[i].qts;
      }
      return sum * Number(1000);
    },

    //TVA
    TVA: function () {
      return this.somme * Number(0.19);
    },
    //somme TTC
    sommeTTC: function () {
      return (this.somme + this.TVA );
    },
    //start here new code
    //somme vergule
    sommeVergule: function () {
      return this.calculDinarsSomme+","+this.calculMillimesSomme;
    },
    //somme ttc vergule
    sommeTTCVergule: function () {
      return this.calculDinarsTTC+","+this.calculMillimesTTC;
    },
    //tva vergule
    TVAVergule: function () {
      return this.calculDinarsTVA+","+this.calculMillimesTVA;
    },

    lengthSomme(){
return this.somme.toString().length;
    },
    lengthSommeTTC(){
return this.sommeTTC.toString().length;
    },
    lengthTVA(){
return this.TVA.toString().length;
    },


    calculMin3Somme(){
      return this.lengthSomme - 3;
    },
      calculMin3TVA(){
      return this.lengthTVA - 3;
    },
    calculMin3TTC(){
      return this.lengthSommeTTC - 3;
    },

    calculDinarsSomme(){
      const a = this.somme.toString();
      return a.substring(0,this.calculMin3Somme);
    },
    calculDinarsTTC(){
      const a = this.sommeTTC.toString();
      return a.substring(0,this.calculMin3TTC);
    },
    calculDinarsTVA(){
      const a = this.TVA.toString();
      return a.substring(0,this.calculMin3TVA);
    },


    calculMillimesSomme(){
      const a = this.somme.toString();
      const b = this.calculDinarsSomme.length;
      return a.substring(b,this.lengthSomme);
    },
    calculMillimesTVA(){
      const a = this.TVA.toString();
      const b = this.calculDinarsTVA.length;
      return a.substring(b,this.lengthTVA);
    },    
    calculMillimesTTC(){
      const a = this.sommeTTC.toString();
      const b = this.calculDinarsTTC.length;
      return a.substring(b,this.lengthSommeTTC);
    },

    somme_fr() {
      const { NumberToLetter } = require("convertir-nombre-lettre");
      const calc =  NumberToLetter(this.calculDinarsTTC);
      return calc +" dinars" + " " +this.calculMillimesTTC +" milimmes";
    },
    somme_fr_tva_zero() {
      const { NumberToLetter } = require("convertir-nombre-lettre");
      const calc =  NumberToLetter(this.calculDinarsSomme);
      return calc +" dinars" + " " +"0,000"+" milimmes";
    },
     
//end here new code
    calculLastNumFac: function () {
         const a = this.last_num_fac.num ;
         const b = parseInt(a);
         return this.numF = b + 1 ;
    },

    all_service() {
      let arr1 = this.programmes;

      let arr2 = this.sCats3;
      let arr4 = this.qts;

      let arr3 = arr1.map((item, i) =>
        Object.assign({}, item, arr2[i], arr4[i])
      );

      console.log(arr3);
      return arr3;
    },
  },
  methods: {
    create_mise_jour(e) {
      let formData = new FormData();
      formData.append("date", this.date_S);

      formData.append("societe_id", this.get_societe_id_mise[0].societe_id);

      formData.append("nb_klm", this.nb_klm);

      //somme
      formData.append("somme", this.sommeVergule);

      
      formData.append("num", this.calculLastNumFac);
      

      if(this.get_societe_id_mise[0].verif_tva ==0) {
        formData.append("TVA", this.TVAVergule);
        formData.append("sommeTTC", this.sommeTTCVergule);
        formData.append("somme_fr", this.somme_fr);
      }

      if(this.get_societe_id_mise[0].verif_tva ==1) {
        formData.append("TVA", '0,000');
        formData.append("somme_fr", this.somme_fr_tva_zero);
        formData.append("sommeTTC", this.sommeVergule);
        
      }

      
      for (var i = 0; i < this.getPrix.length; i++) {
        let prixVergule = this.getPrix[i];
formData.append("programmes[" + i + "][prix]", prixVergule);
      }
      
      for (var i = 0; i < this.programmes.length; i++) {
        const detail_services = "";
        const description = "";

        formData.append("programmes[" + i + "][description]", description);
        formData.append("programmes[" + i + "][Type]", detail_services);

        let titre = this.programmes[i].designation;
        formData.append("programmes[" + i + "][titre]", titre);
        let prix = this.programmes[i].prix;

        formData.append("programmes[" + i + "][prix_ca]", prix);

    

        let qts = this.programmes[i].qts;

        formData.append("programmes[" + i + "][qts]", qts);
      }

      axios
        .post(
          `${apiDomain}/api/mise_a_jour_service_man/${this.$route.params.id}`,
          formData
        )

        .then((res) => {
          this.$noty.success("Service Ajouter avec Succès ! ");

          this.$router.go("-1");

          // this.fetchsearch();
        })
        .catch((error) => {
          if (error.response.status == 422) {
            this.errors = error.response.data.errors;
            this.$noty.error("OOPS ! il y a une erreur essayé de vérifier ");
          }
          if (error.response && error.response.status == 400) {
            this.validationErrors = error.response.data;
          }
        });
    },
    removeProgramme: function (index) {
      Vue.delete(this.programmes, index);
    },
    noop() {
      window.alert("noop");
    },
    reset() {
      this.item = {};
    },
    selectFromParentComponent1() {
      // select option from parent component
      this.item = this.options[0].id;
    },

    Remove(file, index) {
      this.programmes.splice(index, 1);
      this.sCats3.splice(index, 1);
      this.qts.splice(index, 1);
    },
    fetch_get_last_num_fac() {
      axios.get(`${apiDomain}/api/get_last_num_fac`).then(({ data }) => {
        this.last_num_fac = data.num_fac[0];
      
      });
    },
    fetch_get_societe_id($id) {
      axios
        .get(`${apiDomain}/api/fetch_id_societe/${this.$route.params.id}`)

        .then((res) => {
          this.get_societe_id_mise = res.data;
          //this.cat = false;
        })
        .catch((err) => console.log(err));
    },
    

    addNewProgramme: function () {
      this.programmes.push(Vue.util.extend({}, this.programme));
    },

    onSelect(Sous_categorie) {
      this.programmes.push(Sous_categorie);
      this.sCats3.push(detail);

      console.log(this.programmes);
    },
    //detaile push
    onSelectDetails(detail) {
      this.sCats3.push(detail);
      this.qts.push(detail);

      console.log(this.sCats3);
    },

    //Qts push
    onSelectQts(initial_qts) {
      this.qts.push(initial_qts);
      //console.log(this.qts);
      // this.programmes.push(Vue.util.extend({}, this.detaille));
    },

    addNewQTS: function () {
      this.qts.push(Vue.util.extend({}, this.qt));
    },

    showEditModalDetails(detail, index) {
      let obj = {
        // id: Sous_categorie.id,
        detail_services_id: detail.Type,
      };
      this.detailleDetails = obj;
      this.showdetailleModale = true;
      this.index = index;
    },

    showdetailleDetails(detail) {
      this.detailleDetails = detail;
      this.showdetailleModaleDetails = true;
    },

    /* fin detail push */
    showEditModal(Sous_categorie, index) {
      let obj = {
        // id: Sous_categorie.id,
        titre: Sous_categorie.titre_sc,
        description: Sous_categorie.image_sc,
      };
      this.detaille = obj;
      this.showdetailleModale = true;
      this.index = index;
    },

    showdetaille(Sous_categorie) {
      this.detaille = Sous_categorie;
      this.showdetailleModale = true;
    },

    //qts
    /*  showEditModalDetails(qt, index) {
      let obj = {
        // id: Sous_categorie.id,
        qts: qt.qts,
      };
      this.detailleQts = obj;
      this.showdetailleModale = true;
      this.index = index;
    },

    showdetailleDetails(qt) {
      this.detailleDetails = qt;
      this.showdetailleModaleQts = true;
    }, */

    getCategories() {
      axios
        .get(`${apiDomain}/api/listeCtegoriesSubCategg`)

        .then((res) => {
          /*        this.showPart1 = true;
        this.showPart2 = true; */
          this.Cats = res.data;
          //this.cat = false;
        })
        .catch((err) => console.log(err));
    },

    /*   fetchCatTypes3() {
      axios
        .get(`${apiDomain}/api/fetchCatTypes3`)

        .then((res) => {
          this.showPart3 = false;
          this.showPart4 = true;
          this.detail_services = res.data;
          //this.cat = false;
        })
        .catch((err) => console.log(err));
    }, */

    fetchCatTypes3(id) {
      axios.get(`${apiDomain}/api/getTypes3/${id}`).then(({ data }) => {
        this.sCats33 = data.sous_cat;
        // this.nameFatherCat = data.cat.titreCategorie;
      });
    },

    get_societe_services() {
      axios
        .get(`${apiDomain}/api/all_societe`)

        .then((res) => {
          this.all_societe = res.data;
          //this.cat = false;
        })
        .catch((err) => console.log(err));
    },

    fetch_get_matrs(id) {
      axios.get(`${apiDomain}/api/get_matrs/${id}`).then(({ data }) => {
        this.options = data.sous_cat;
        // this.nameFatherCat = data.cat.titreCategorie;
      });
    },

    fetchCatTypes(id) {
      axios.get(`${apiDomain}/api/getTypes/${id}`).then(({ data }) => {
        this.sCats = data.sous_cat;
        // this.nameFatherCat = data.cat.titreCategorie;
      });
    },
  },
};
</script>

<style lang="scss" >
.glow-on-hover {
  width: 90px;
  height: 76px;
  border: none;
  outline: none;
  color: #fff;
  background: #24b2dc;
  cursor: pointer;
  position: relative;
  z-index: 0;
  border-radius: 10px;
}

.glow-on-hover:before {
  content: "";
  /*   background: #20b3b3;
  color: #fff; */
  background: linear-gradient(
    45deg,
    #ff0000,
    #ff7300,
    #fffb00,
    #48ff00,
    #00ffd5,
    #002bff,
    #7a00ff,
    #ff00c8,
    #ff0000
  );
  position: absolute;
  top: -2px;
  left: -2px;
  background-size: 400%;
  z-index: -1;
  filter: blur(5px);
  width: calc(100% + 4px);
  height: calc(100% + 4px);
  animation: glowing 20s linear infinite;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  border-radius: 10px;
}

.glow-on-hover:active {
  color: #000;
}

.glow-on-hover:active:after {
  background: transparent;
}

.glow-on-hover:hover:before {
  opacity: 1;
}

.glow-on-hover:after {
  z-index: -1;
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  background: #de8e15;
  left: 0;
  top: 0;
  border-radius: 10px;
}

@keyframes glowing {
  0% {
    background-position: 0 0;
  }
  50% {
    background-position: 400% 0;
  }
  100% {
    background-position: 0 0;
  }
}

/* ***** */
.custom-input {
  text-align: center;
  color: #fff;
  font-weight: bold;
  font-size: 1.4em;
  background-color: #341677;
}
</style>